import React from 'react';
import { FORM_LINKS } from '../constants';

const FormLinksSection = ({ 
  formData, 
  accountTypes,
  handleCheckboxChange 
}) => {
  // If no account types loaded yet, don't show anything
  if (!accountTypes || accountTypes.length === 0) {
    return null;
  }

  const accountName = accountTypes.find(type => type.id == formData.accountType)?.name;
  
  // Show form links only for DEPED ACCOUNT and M365 ACCOUNT
  const shouldShowFormLinks = formData.accountType && formData.actionType && accountName && 
    (accountName === 'DEPED ACCOUNT' || accountName === 'M365 ACCOUNT');

  if (!shouldShowFormLinks) return null;

  const getFormLink = () => {
    // Map account names to correct FORM_LINKS keys
    let accountTypeKey;
    if (accountName === 'DEPED ACCOUNT') {
      accountTypeKey = 'DEPED_ACCOUNT';
    } else if (accountName === 'M365 ACCOUNT') {
      accountTypeKey = 'M365';
    } else {
      accountTypeKey = accountName.replace(' ACCOUNT', '');
    }
    
    if (FORM_LINKS[accountTypeKey]) {
      return FORM_LINKS[accountTypeKey][formData.actionType];
    }
    return '';
  };

  const getFormTitle = () => {
    const action = formData.actionType === 'CREATE' ? 'Creation' : 'Reset';
    
    // Add specific descriptions based on the actual form purposes
    if (accountName === 'DEPED ACCOUNT') {
      if (formData.actionType === 'CREATE') {
        return 'DEPED Email Creation Form';
      } else {
        return 'DEPED Email Reset Form';
      }
    } else if (accountName === 'M365 ACCOUNT') {
      if (formData.actionType === 'CREATE') {
        return 'DEPED 365 Account Creation Form';
      } else {
        return 'DEPED 365 Reset Facility Form';
      }
    }
    
    return `${accountName} ${action} Form`;
  };

  return (
    <div className="col-span-full mt-4 p-4 sm:p-6 bg-gray-50 rounded-lg sm:rounded-xl border border-black/10">
      <h3 className="text-black font-semibold mb-3 sm:mb-4 font-poppins text-base sm:text-lg">
        Required Form Links
      </h3>
      
      <div className="flex flex-col gap-3 sm:gap-4">
        <a
          href={getFormLink()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex items-center justify-center gap-2 px-4 py-3 border border-gray-300 rounded-lg font-medium font-poppins text-gray-700 hover:bg-gray-50 transition-colors duration-200"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
          {getFormTitle()}
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </a>
        
        <div className="mt-4 pt-4 border-t border-dashed border-black/20 flex flex-col gap-3">
          <p className="font-semibold text-gray-800 font-poppins text-sm">
            Please complete the following steps before submitting:
          </p>
          
           <ol className="pl-6 m-0 space-y-1">
             <li className="text-gray-600 text-sm font-poppins">Click the "{getFormTitle()}" link above</li>
             <li className="text-gray-600 text-sm font-poppins">
               Fill out all required information in the {accountName === 'M365 ACCOUNT' && formData.actionType === 'CREATE' ? 'Google Sheets' : 'Excel'} form
             </li>
             <li className="text-gray-600 text-sm font-poppins">Check the confirmation checkbox below</li>
           </ol>
          
          <div className="flex items-center mt-3 bg-blue-50 p-4 rounded-lg border border-blue-200">
            <input
              type="checkbox"
              checked={formData.formCompleted}
              onChange={(e) => handleCheckboxChange(e.target.checked)}
              id="form-completed-checkbox"
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
            />
            <label 
              htmlFor="form-completed-checkbox" 
              className="ml-3 text-sm font-medium text-gray-700 cursor-pointer font-poppins"
            >
              I confirm that I have completed the required form
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLinksSection; 